import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: 8px;
  align-items: center;

  white-space: nowrap;
`

export const ProviderImage = styled.img`
  width: 20px;
  height: 20px;
`

export const Username = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`
